import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT

/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getListData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/listTable', qs.stringify(params));
}

export const listTableCompute = (params) => {
  return axios.post(root + '/recharge/rechargerecord/listTableCompute', qs.stringify(params));
}

export const listOneCus = (params) => {
  return axios.post(root + '/recharge/rechargerecord/listOneCus', qs.stringify(params));
}

export const updateshowdiscount = (params) => {
  return axios.post(root + '/recharge/rechargerecord/updateshowdiscount', qs.stringify(params));
}

/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getRechargeList = (params) => {
  return axios.post(root + '/recharge/rechargerecord/list', qs.stringify(params));
}


export const updateSellSimple = (params) => {
  return axios.post(root + '/order/jxcglassessell/updateSimple', qs.stringify(params));
}
export const backSellCash = (params) => {
  return axios.post(root + '/recharge/rechargerecord/backSellCash', qs.stringify(params));
}
export const getrefundOrder = (params) => {
  return axios.post(root + '/recharge/rechargerecord/getrefundOrder', qs.stringify(params));
}
/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const saveData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/save', qs.stringify(params));
}
export const changePaymethod = (params) => {
  return axios.post(root + '/recharge/rechargerecord/changePaymethod', qs.stringify(params));
}

export const cancelData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/cancel', qs.stringify(params));
}

export const updateVerify = (params) => {
  return axios.post(root + '/recharge/rechargerecord/updateVerify', qs.stringify(params));
}


/**
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const initData = (params) => {
  return axios.post(root + '/recharge/rechargerecord/initData', qs.stringify(params),{noloading:true});
}
/**
 * 账户充值、现金收入
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const summary = (params) => {
  return axios.post(root + '/recharge/rechargerecord/summary', qs.stringify(params));
}

export const subAll = (params) => {
  return axios.post(root + '/recharge/rechargerecord/subAll', qs.stringify(params));
}


export const industry = (params) => {
  return axios.post(root + '/weixin/industry', qs.stringify(params));
}

export const allunionpaymid = (params) => {
  return axios.post(root + '/recharge/rechargerecord/allunionpaymid', qs.stringify(params));
}


export const bcreateBackOrder= (params) => {
  return axios.post(root + '/order/jxcglassessell/bcreateBackOrder', qs.stringify(params));
}

export const removeGroupbuy= (params) => {
  return axios.post(root + '/recharge/rechargerecord/removeGroupbuy', qs.stringify(params));
}

export const auditflow= (params) => {
  return axios.post(root + '/wf/todolist/auditflow', qs.stringify(params));
}



// WEBPACK FOOTER //
// ./src/api/set/recharge.js